import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { IUser, UserData } from 'src/app/data-types/user-data';

@Component({
    selector: 'app-create-customer',
    templateUrl: './create-customer.component.html',
    styleUrls: ['./create-customer.component.scss'],
})
export class CreateCustomerComponent implements OnChanges {
    @Input() form: FormGroup;
    @Input() selectedUser: IUser;

    extended = false;

    newCustomer: FormGroup;

    constructor(private fb: FormBuilder) {}

    ngOnChanges(): void {
        if (!this.extended) {
            this.extendFormControls();
            this.extended = true;
        }
        if (this.selectedUser) {
            this.newCustomer.controls.firstname.setValue(this.selectedUser.firstname);
            this.newCustomer.controls.surname.setValue(this.selectedUser.surname);
            this.newCustomer.controls.email.setValue(this.selectedUser.email);
            this.newCustomer.controls.phone.setValue(this.selectedUser.mobile);
        } else {
            this.newCustomer.controls.firstname.setValue(null);
            this.newCustomer.controls.surname.setValue(null);
            this.newCustomer.controls.email.setValue(null);
            this.newCustomer.controls.phone.setValue(null);
        }
    }

    private extendFormControls() {
        this.newCustomer = this.fb.group({
            firstname: new FormControl(null, [Validators.required]),
            surname: new FormControl(null, [Validators.required]),
            phone: new FormControl(null, [Validators.required]),
            email: new FormControl(null, [Validators.required, Validators.email]),
            modified: new FormControl(false),
        });

        this.form.addControl('newCustomer', this.newCustomer);

        this.newCustomer.valueChanges.subscribe((values) => {
            if (this.isUserSelectAndModified()) {
                this.newCustomer.controls.modified.setValue(true, { emitEvent: false });
            } else {
                this.newCustomer.controls.modified.setValue(false, { emitEvent: false });
            }

            const newCustomer: FormGroup = this.form.controls.newCustomer as FormGroup;
            const emailControl = newCustomer.controls.email;
            const phoneControl = newCustomer.controls.phone;

            if (emailControl.valid) {
                phoneControl.removeValidators(Validators.required);
                if (phoneControl.errors?.required) {
                    phoneControl.setErrors(null);
                }
            } else {
                newCustomer.controls.phone.addValidators(Validators.required);
            }
            if (phoneControl.valid) {
                emailControl.removeValidators(Validators.required);
                if (emailControl.errors?.required) {
                    emailControl.setErrors(null);
                }
            } else {
                emailControl.addValidators(Validators.required);
            }
        });
    }

    private isUserSelectAndModified() {
        if (!this.selectedUser) return false;
        const formValues = this.newCustomer.value;
        if (
            this.selectedUser.firstname !== formValues.firstname ||
            this.selectedUser.surname !== formValues.surname ||
            this.selectedUser.mobile !== formValues.phone ||
            this.selectedUser.email !== formValues.email
        ) {
            return true;
        }

        return false;
    }
}
